// API
// ----------------------------------------------------------------------

// export const HOST_API = process.env.REACT_APP_HOST_API || 'http://localhost:3001';
// config.js
export const HOST_API = 'https://server-medical-blog.vercel.app/';
